export default "/icon-nav-templates.svg";